(function () {
  'use strict';

  const PRODUCTS_PER_PAGE = 20;

  const root = document.querySelector('[data-archive-root]');
  if (!root) return;

  const sectionId = root.getAttribute('data-section-id');
  const basePath = root.getAttribute('data-base-path') || window.location.pathname;
  const productContainer = document.getElementById('productContainer');
  const prevPageButton = document.getElementById('prevPageButton');
  const nextPageButton = document.getElementById('nextPageButton');
  const loadingEl = root.querySelector('[data-archive-loading]');
  const initialDataEl = root.querySelector('[data-archive-products]');

  let allProducts = [];
  let currentPage = 1;
  let optionChanged = 'yes';

  function norm(value) {
    return (value == null ? '' : String(value)).trim().toLowerCase();
  }

  function parseProductsScript(el) {
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      console.error('Archive filter: failed to parse products JSON', err);
      return [];
    }
  }

  function extractProductsFromHTML(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const script = doc.querySelector('[data-archive-products]');
    return parseProductsScript(script);
  }

  async function fetchPage(page) {
    const urls = [];
    if (sectionId) {
      urls.push(`${basePath}?section_id=${encodeURIComponent(sectionId)}&page=${page}`);
    }
    urls.push(`${basePath}?page=${page}`);

    for (const url of urls) {
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) {
          console.warn(`[archives] ${url} responded ${response.status}`);
          continue;
        }
        const html = await response.text();
        const chunk = extractProductsFromHTML(html);
        if (chunk.length > 0) return chunk;
      } catch (err) {
        console.warn(`[archives] failed to fetch ${url}`, err);
      }
    }
    return [];
  }

  async function fetchRemainingPages(totalPages) {
    if (totalPages <= 1) return [];
    const results = [];
    for (let page = 2; page <= totalPages; page++) {
      const chunk = await fetchPage(page);
      results.push(...chunk);
    }
    return results;
  }

  function getSelectedValues(name) {
    return Array.from(document.querySelectorAll(`input[name="${name}"]:checked`))
      .map((cb) => norm(cb.value));
  }

  function filterAndDisplay() {
    const selectedCollaborations = getSelectedValues('collaboration');
    const selectedIdentifiers = getSelectedValues('ARCHIVE INDICATOR');
    const selectedSupply = getSelectedValues('SUPPLY INDICATOR');

    const filtered = allProducts.filter((product) => {
      const collab = norm(product.collaborationMetafield);
      const archive = norm(product.archiveIndicatorMetafield);
      const supply = norm(product.supplyIndicatorMetafield);

      const matchesCollab = !selectedCollaborations.length || selectedCollaborations.includes(collab);
      const matchesArchive = !selectedIdentifiers.length || selectedIdentifiers.includes(archive);
      const matchesSupply = !selectedSupply.length || selectedSupply.includes(supply);

      return matchesCollab && matchesArchive && matchesSupply;
    });

    displayProducts(filtered);
    updatePaginationButtons(filtered);
  }

  function displayProducts(productsToDisplay) {
    productContainer.innerHTML = '';

    let start;
    if (optionChanged === 'no') {
      start = (currentPage - 1) * PRODUCTS_PER_PAGE;
    } else {
      start = 0;
      currentPage = 1;
    }
    const end = Math.min(start + PRODUCTS_PER_PAGE, productsToDisplay.length);

    if (productsToDisplay.length === 0) {
      const empty = document.createElement('li');
      empty.className = 'archive-empty';
      empty.textContent = 'No archives match the selected filters.';
      productContainer.appendChild(empty);
      return;
    }

    const frag = document.createDocumentFragment();
    for (let i = start; i < end; i++) {
      const product = productsToDisplay[i];
      const li = document.createElement('li');
      li.innerHTML = `
        <div class="archive-img">
          <img src="${escapeAttr(product.image)}" alt="${escapeAttr(product.title)}">
        </div>
        <div class="archive-content">
          <div class="supply-img-wrap">
            <h2 class="sr-only">${escapeHTML(product.title)}</h2>
            <img src="${escapeAttr(product.identifierImageMetafield)}" alt="Identifier Image for ${escapeAttr(product.title)}">
          </div>
          <div class="archive-meta-wrap">
            <dl>
              <div>
                <dt>Collaboration:</dt>
                <dd>${escapeHTML(product.collaborationMetafield)}</dd>
              </div>
              <div>
                <dt>Authentication:</dt>
                <dd>${escapeHTML(product.authenticationNameMetafield)}</dd>
              </div>
              <div>
                <dt>Archive Indicator:</dt>
                <dd>${escapeHTML(product.archiveIndicatorMetafield)}</dd>
              </div>
              <div>
                <dt>Supply Indicator:</dt>
                <dd>${escapeHTML(product.supplyIndicatorMetafield)}</dd>
              </div>
            </dl>
          </div>
          <a href="/products/${encodeURIComponent(product.handle)}">View Print</a>
        </div>
      `;
      frag.appendChild(li);
    }
    productContainer.appendChild(frag);
  }

  function escapeHTML(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(value) {
    return escapeHTML(value);
  }

  function updatePaginationButtons(productsToDisplay) {
    prevPageButton.disabled = currentPage <= 1;
    nextPageButton.disabled = currentPage * PRODUCTS_PER_PAGE >= productsToDisplay.length;
  }

  function scrollToProductContainer() {
    const top = productContainer.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function logAvailableFilterValues() {
    if (!allProducts.length) return;
    const unique = (key) => Array.from(new Set(allProducts.map((p) => norm(p[key])))).sort();
    console.log(
      '[archives] loaded %d products. archive indicators: %o, collaborations: %o, supply indicators: %o',
      allProducts.length,
      unique('archiveIndicatorMetafield'),
      unique('collaborationMetafield'),
      unique('supplyIndicatorMetafield')
    );
  }

  function bindEvents() {
    root.querySelectorAll(
      'input[name="collaboration"], input[name="ARCHIVE INDICATOR"], input[name="SUPPLY INDICATOR"]'
    ).forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        optionChanged = 'yes';
        filterAndDisplay();
      });
    });

    prevPageButton.addEventListener('click', () => {
      optionChanged = 'no';
      currentPage = Math.max(1, currentPage - 1);
      filterAndDisplay();
      scrollToProductContainer();
    });

    nextPageButton.addEventListener('click', () => {
      optionChanged = 'no';
      currentPage += 1;
      filterAndDisplay();
      scrollToProductContainer();
    });
  }

  async function init() {
    const totalPages = parseInt(initialDataEl && initialDataEl.getAttribute('data-total-pages'), 10) || 1;
    const page1 = parseProductsScript(initialDataEl);
    allProducts = page1.slice();

    if (totalPages > 1) {
      const rest = await fetchRemainingPages(totalPages);
      allProducts = allProducts.concat(rest);
    }

    if (loadingEl) loadingEl.style.display = 'none';

    logAvailableFilterValues();
    bindEvents();
    filterAndDisplay();
  }

  init();
})();
